export const CONTRACT_CATEGORIES = [
  // Construction & Building
  'Construction',
  'Architecture',
  'Interior Design',
  'Structural Engineering',
  'Civil Engineering',
  'Electrical Work',
  'Plumbing',
  'HVAC',
  'Carpentry',
  'Masonry',
  'Roofing',
  'Painting & Decorating',
  'Landscaping',
  'Renovation & Remodeling',
  
  // Technology & Development
  'Web Development',
  'Mobile App Development',
  'Software Development',
  'UI/UX Design',
  'Game Development',
  'Database Administration',
  'DevOps & Cloud',
  'Cybersecurity',
  'IT Support',
  
  // Design & Creative
  'Graphic Design',
  'Brand Design',
  '3D Modeling & Rendering',
  'Animation',
  'Video Production',
  'Photography',
  'Audio Production',
  'Illustration',
  
  // Business & Professional
  'Marketing',
  'Digital Marketing',
  'Social Media Management',
  'Content Writing',
  'Copywriting',
  'SEO & SEM',
  'Sales',
  'Business Consulting',
  'Legal Services',
  'Accounting & Finance',
  'HR & Recruitment',
  'Project Management',
  
  // Specialized Services
  'Event Planning',
  'Translation',
  'Virtual Assistant',
  'Customer Support',
  'Data Entry',
  'Research & Analysis',
  'Teaching & Tutoring',
  
  'Other',
];

export const PRODUCT_CATEGORIES = [
  'Electronics',
  'Furniture',
  'Clothing',
  'Books',
  'Sports & Fitness',
  'Home & Garden',
  'Toys & Games',
  'Automotive',
  'Tools & Equipment',
  'Art & Collectibles',
  'Musical Instruments',
  'Other',
];

// For backward compatibility
export const JOB_CATEGORIES = CONTRACT_CATEGORIES;
